import { getSrcsetData } from "../../../../Utils/Image";

export const init = function (tag: HTMLImageElement, img: string) {
    const imgSrcset = getSrcsetData(img);
    tag.src = imgSrcset.src;
    tag.srcset = imgSrcset.srcset;
    tag.sizes = imgSrcset.sizes;
};
